import { createAction } from '@reduxjs/toolkit';

export const addCategoryHierarchyData = createAction('catalog/add_category_hierarchy_data');
export const addRootCategoryHierarchyData = createAction('catalog/add_root_category_hierarchy_data');